import React, { FC } from 'react';
import { Button, Col, Result, Row, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { history } from '..';
import { usePermissions } from '~/hooks';

const NoPermission: FC = () => {
  const [t] = useTranslation();
  const goBack = () => {
    history.goBack();
  };

  const { roles, loading } = usePermissions();

  const getSubTitle = (): string => {
    const getRoleStr = () => {
      return roles.map((item) => t(`employees:${item}`)).join(', ');
    };
    if (roles.length === 0)
      return "It's seems that roles hasn't been saved in Redux state (ui.permissions)";
    if (roles.length === 1) return t('permissionDeniedInfo', { role: getRoleStr() });
    return t('permissionDeniedInfoMany', { role: getRoleStr() });
  };

  if (loading)
    return (
      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    );

  return (
    <Result
      status="403"
      title={t('permissionDenied')}
      subTitle={getSubTitle()}
      extra={
        <Button type="primary" onClick={goBack}>
          {t('goBack')}
        </Button>
      }
    />
  );
};

export default NoPermission;
